module.exports = __webpack_public_path__ + "static/img/logo.5181d5bf.png";